
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1fOao", function(module, exports) {
// This is another layer on top of the AFE ManualRulesContainer.
// It is necessary that this container wraps the entire "automation" component and not nested. Else the user input form will not render correctly.
// This container provides an automation context to all children components through the useAutomationMenu hook.

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $b7C1K = parcelRequire("b7C1K");


var $l998X = parcelRequire("l998X");





var $fBMbo = parcelRequire("fBMbo");


var $6xdDU = parcelRequire("6xdDU");


var $9Begw = parcelRequire("9Begw");




parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");





var $ccHMk = parcelRequire("ccHMk");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $3eD0p = parcelRequire("3eD0p");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");




const $58bb86fd209f1a14$var$messages = (0, $cgtv4.defineMessages)({
    successFlag: {
        id: "automation-platform.common.success-flag",
        defaultMessage: "Your automation is in progress"
    },
    failureFlagTitle: {
        id: "automation-platform.common.failure-flag-title",
        defaultMessage: "Oops we ran into a problem"
    },
    failureFlagDescription: {
        id: "automation-platform.common.failure-flag-description",
        defaultMessage: "There was a problem and we couldn't run the automation '{0}'"
    },
    partialFailureFlagDescription: {
        id: "automation-platform.common.partial-failure-flag-description",
        defaultMessage: "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues"
    },
    errorInputMustNotBeEmpty: {
        id: "automation-platform.common.error-input-must-not-be-empty",
        defaultMessage: "Input must not be empty"
    },
    errorInputCharacterLimitReached: {
        id: "automation-platform.common.error-input-character-limit-reached",
        defaultMessage: "Provided value exceeds the character limit for the field."
    },
    inputRequiredForAction: {
        id: "automation-platform.common.input-required-for-action",
        defaultMessage: "Your input is required to complete this action"
    },
    errorInputTypeIsNotSupported: {
        id: "automation-platform.common.error-input-type-is-not-supported",
        defaultMessage: "Input type not supported yet"
    },
    errorValueIsNotValidNumber: {
        id: "automation-platform.common.error-value-is-not-valid-number",
        defaultMessage: "The value is not a valid number"
    },
    cancelButtonTitle: {
        id: "automation-platform.common.cancel-button-title",
        defaultMessage: "Cancel"
    },
    continueButtonTitle: {
        id: "automation-platform.common.continue-button-title",
        defaultMessage: "Continue"
    }
});
var $58bb86fd209f1a14$export$2e2bcd8739ae039 = $58bb86fd209f1a14$var$messages;


var $2e786fc3a725eb31$export$955ccc93b55d5904 = /*#__PURE__*/ function(UserInputType) {
    UserInputType["NUMBER"] = "NUMBER";
    UserInputType["TEXT"] = "TEXT";
    UserInputType["BOOLEAN"] = "BOOLEAN";
    UserInputType["DROPDOWN"] = "DROPDOWN";
    UserInputType["PARAGRAPH"] = "PARAGRAPH";
    return UserInputType;
}({});
const $2e786fc3a725eb31$export$4b79f735ed858abe = 'business';
const $2e786fc3a725eb31$export$417275bac62d38d2 = 'software';
const $2e786fc3a725eb31$export$9c9c9eaf8c092006 = 'service_desk';
const $2e786fc3a725eb31$export$e9fe9a39cc7f5103 = 'product_discovery';
const $2e786fc3a725eb31$export$e9c56aa3b027d98f = 'customer_service';





parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $3Sibj = parcelRequire("3Sibj");























const $c51bfeda0c8567ad$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("iyOBx")),
    da: ()=>(parcelRequire("jsRDj")),
    de: ()=>(parcelRequire("jPkry")),
    en_GB: ()=>(parcelRequire("6U5fO")),
    en_ZZ: ()=>(parcelRequire("fBcrb")),
    en: ()=>Promise.resolve((parcelRequire("3Sibj"))),
    es: ()=>(parcelRequire("0Wkda")),
    fi: ()=>(parcelRequire("c19lr")),
    fr: ()=>(parcelRequire("lNzdD")),
    hu: ()=>(parcelRequire("bvax8")),
    it: ()=>(parcelRequire("kwuXM")),
    ja: ()=>(parcelRequire("9Vmiq")),
    ko: ()=>(parcelRequire("iMCok")),
    nb: ()=>(parcelRequire("8OMYj")),
    nl: ()=>(parcelRequire("3N9j9")),
    pl: ()=>(parcelRequire("bY50g")),
    pt_BR: ()=>(parcelRequire("8stZc")),
    ru: ()=>(parcelRequire("lWYjb")),
    sv: ()=>(parcelRequire("3eNpQ")),
    tr: ()=>(parcelRequire("hGqDY")),
    zh_TW: ()=>(parcelRequire("5bE1l")),
    zh: ()=>(parcelRequire("a4LUc"))
};
const $c51bfeda0c8567ad$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $c51bfeda0c8567ad$var$fetchMessagesForLocale = async (locale, locales)=>{
    try {
        const targetLocale = ($c51bfeda0c8567ad$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in locales) {
            const messages = await locales[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in locales) {
            const messages = await locales[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    // Set English as default.
    return 0, $3Sibj.default;
};
const $c51bfeda0c8567ad$var$createLoaderFunction = (locales)=>{
    // Since loaderFn expects a single argument, we need this wrapper function to pass in the locales object to fetchMessagesForLocale.
    return async (locale)=>{
        return $c51bfeda0c8567ad$var$fetchMessagesForLocale(locale, locales);
    };
};
const $c51bfeda0c8567ad$export$ddf313a17c78c281 = ({ locales: locales, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        loaderFn: $c51bfeda0c8567ad$var$createLoaderFunction(locales),
        children: children
    });
};





parcelRequire("42omo");





var $7gpC4 = parcelRequire("7gpC4");


var $6rSJC = parcelRequire("6rSJC");

const $d57249674e1928bc$var$BooleanInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $fBMbo.di)((0, $7gpC4.default), (0, $6rSJC.default));
    const { variableName: variableName, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6rSJC.default), {
        name: variableName,
        defaultIsChecked: defaultValue || false,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                ...fieldProps,
                label: displayName
            })
    });
};
var $d57249674e1928bc$export$2e2bcd8739ae039 = $d57249674e1928bc$var$BooleanInputPrompt;





parcelRequire("42omo");










var $fb3kw = parcelRequire("fb3kw");


var $4noo5 = parcelRequire("4noo5");


var $b9ca042666076337$export$b8e9cd941e8016ac = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["INVALID_NUMBER"] = "INVALID_NUMBER";
    return Errors;
}({});
const $b9ca042666076337$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return "EMPTY";
    if (value && Number.isNaN(Number(value))) return "INVALID_NUMBER";
    return undefined;
};
const $b9ca042666076337$var$NumberInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $fBMbo.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $4noo5.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const generateErrorMessage = (error)=>{
        switch(error){
            case "EMPTY":
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).errorInputMustNotBeEmpty
                    })
                });
            case "INVALID_NUMBER":
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).errorValueIsNotValidNumber
                    })
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        "aria-required": required,
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: (value)=>$b9ca042666076337$export$c6cbc3bbef9e5a54(required, value),
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        ...fieldProps
                    }),
                    generateErrorMessage(error)
                ]
            })
    }, variableName);
};
var $b9ca042666076337$export$2e2bcd8739ae039 = $b9ca042666076337$var$NumberInputPrompt;





parcelRequire("42omo");













var $9EtP6 = parcelRequire("9EtP6");


var $33686cdbcd59ec20$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["CHARACTER_LIMIT"] = "CHARACTER_LIMIT";
    return Errors;
}($33686cdbcd59ec20$var$Errors || {});
const $33686cdbcd59ec20$var$MAX_PARAGRAPH_CHARACTER_LIMIT = 5000;
const $33686cdbcd59ec20$var$ParagraphInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $fBMbo.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $9EtP6.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        if (value && value?.trim().length === 0) return "EMPTY";
        if (value && value.length > $33686cdbcd59ec20$var$MAX_PARAGRAPH_CHARACTER_LIMIT) return "CHARACTER_LIMIT";
        return undefined;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).errorInputMustNotBeEmpty
                        })
                    }),
                    error === "CHARACTER_LIMIT" && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).errorInputCharacterLimitReached
                        })
                    })
                ]
            })
    });
};
var $33686cdbcd59ec20$export$2e2bcd8739ae039 = $33686cdbcd59ec20$var$ParagraphInputPrompt;





parcelRequire("42omo");













var $2gD2K = parcelRequire("2gD2K");


var $d969a0131b921f31$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($d969a0131b921f31$var$Errors || {});
const $d969a0131b921f31$var$SelectInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $fBMbo.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $2gD2K.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        return undefined;
    };
    const selectOptions = defaultValue.map((value)=>({
            label: value,
            value: value
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                        isClearable: true,
                        isSearchable: true,
                        options: selectOptions,
                        menuPosition: "fixed",
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).errorInputMustNotBeEmpty
                        })
                    })
                ]
            })
    });
};
var $d969a0131b921f31$export$2e2bcd8739ae039 = $d969a0131b921f31$var$SelectInputPrompt;





parcelRequire("42omo");
















var $1c4484a0ac3321a8$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($1c4484a0ac3321a8$var$Errors || {});
const $1c4484a0ac3321a8$var$TextInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $fBMbo.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $4noo5.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>required && !value ? "EMPTY" : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).errorInputMustNotBeEmpty
                        })
                    })
                ]
            })
    });
};
var $1c4484a0ac3321a8$export$2e2bcd8739ae039 = $1c4484a0ac3321a8$var$TextInputPrompt;


const $be85f4683a10666c$export$a3f697c029ab2691 = (props)=>{
    (0, $fBMbo.di)((0, $d57249674e1928bc$export$2e2bcd8739ae039), (0, $ccHMk.default), (0, $gQhRa.ErrorMessage), (0, $fzqvY.default), (0, $3eD0p.default), (0, $8CZUH.default), (0, $1DHa6.default), (0, $8o1lj.default), (0, $9ot3w.default), (0, $d8eRd.default), (0, $b9ca042666076337$export$2e2bcd8739ae039), (0, $d969a0131b921f31$export$2e2bcd8739ae039), (0, $1c4484a0ac3321a8$export$2e2bcd8739ae039));
    const { selectedRule: selectedRule, clearSelectedRule: clearSelectedRule, invokeRule: invokeRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const { rule: rule, objects: objects } = selectedRule;
    const { userInputPrompts: userInputPrompts } = rule;
    const getTypeOfInput = (key, prompts)=>prompts.find(({ variableName: variableName })=>variableName === key)?.inputType;
    const generateInputValue = (inputType, data)=>{
        switch(inputType){
            case (0, $2e786fc3a725eb31$export$955ccc93b55d5904).DROPDOWN:
                return {
                    inputType: inputType,
                    value: data ? data.value : ''
                };
            case (0, $2e786fc3a725eb31$export$955ccc93b55d5904).NUMBER:
                return {
                    inputType: inputType,
                    value: Number(data)
                };
            default:
                return {
                    inputType: inputType,
                    value: data
                };
        }
    };
    const handleSubmit = (data)=>{
        const output = Object.entries(data).reduce((acc, [key, value])=>{
            const inputType = getTypeOfInput(key, userInputPrompts);
            if (!inputType) return acc;
            acc[key] = generateInputValue(inputType, value);
            return acc;
        }, {});
        return invokeRule(rule.id, objects, output);
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedRule();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateUserInputForm = (inputPrompt)=>{
        switch(inputPrompt.inputType){
            case (0, $2e786fc3a725eb31$export$955ccc93b55d5904).TEXT:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $1c4484a0ac3321a8$export$2e2bcd8739ae039), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $2e786fc3a725eb31$export$955ccc93b55d5904).NUMBER:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $b9ca042666076337$export$2e2bcd8739ae039), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $2e786fc3a725eb31$export$955ccc93b55d5904).DROPDOWN:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $d969a0131b921f31$export$2e2bcd8739ae039), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $2e786fc3a725eb31$export$955ccc93b55d5904).BOOLEAN:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $d57249674e1928bc$export$2e2bcd8739ae039), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $2e786fc3a725eb31$export$955ccc93b55d5904).PARAGRAPH:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $33686cdbcd59ec20$export$2e2bcd8739ae039), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            default:
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("br", {}),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).errorInputTypeIsNotSupported
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("br", {})
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c51bfeda0c8567ad$export$ddf313a17c78c281), {
        locales: (0, $c51bfeda0c8567ad$export$df1c34db1371eeed),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            "data-testid": "automation-platform.ui.manual-rules-container.manual-triggers-form.modal",
            onClose: handleClose,
            onOpenComplete: handleOpen,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                onSubmit: handleSubmit,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                                hasCloseButton: true,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                    children: rule.name
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).inputRequiredForAction
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3eD0p.default), {
                                        children: userInputPrompts.map(generateUserInputForm)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "subtle",
                                        onClick: handleClose,
                                        isDisabled: submitting,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).cancelButtonTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "primary",
                                        type: "submit",
                                        isLoading: submitting,
                                        autoFocus: true,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $58bb86fd209f1a14$export$2e2bcd8739ae039).continueButtonTitle
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        })
    });
};
var $be85f4683a10666c$export$2e2bcd8739ae039 = $be85f4683a10666c$export$a3f697c029ab2691;


const $3dc9b564e50a41bb$export$96513fc6544cb4e5 = (env, site, query)=>{
    const [initialised, setInitialised] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const [rules, setRules] = (0, $42omo.useState)([]);
    const transformRules = (ruleResponse)=>{
        const rulesUnsorted = Object.values(ruleResponse);
        return rulesUnsorted.sort((rule1, rule2)=>rule1.name.localeCompare(rule2.name));
    };
    const triggerFetch = async ()=>{
        setInitialised(false);
        try {
            const fetchedRules = await (0, $9Begw.searchManuallyTriggeredRules)(env, site, query);
            setError(null);
            setRules(transformRules(fetchedRules));
        } catch (e) {
            setError(e);
            setRules([]);
        } finally{
            setInitialised(true);
        }
    };
    return [
        triggerFetch,
        initialised,
        error,
        rules
    ];
};
const $3dc9b564e50a41bb$export$eb0a81e78d942dba = (props)=>{
    (0, $fBMbo.di)((0, $6xdDU.default), (0, $be85f4683a10666c$export$2e2bcd8739ae039), (0, $9Begw.invokeManuallyTriggeredRule), $3dc9b564e50a41bb$export$96513fc6544cb4e5, (0, $42omo.useMemo), (0, $42omo.useState));
    const { env: env, site: site, query: query, children: children, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed, onRuleInvocationLifecycleStarted: onRuleInvocationLifecycleStarted, onRuleInvocationSuccess: onRuleInvocationSuccess, onRuleInvocationFailure: onRuleInvocationFailure, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone } = props;
    // Initial data loading state
    const [triggerFetch, initialised, error, rules] = $3dc9b564e50a41bb$export$96513fc6544cb4e5(env, site, query);
    // We store a rule in state here if and only if a rule has user inputs, and thus
    // we need to preserve state while the input dialog is open.
    const [selectedRule, setSelectedRule] = (0, $42omo.useState)(null);
    const clearSelectedRule = ()=>{
        setSelectedRule(null);
    };
    // Value set when a rule is invoking, either from the dialog or without dialog
    const [invokingRuleId, setInvokingRuleId] = (0, $42omo.useState)(null);
    // Memoized projection of rules by id
    const rulesById = (0, $42omo.useMemo)(()=>rules.reduce((acc, rule)=>({
                // eslint-disable-next-line
                ...acc,
                [rule.id]: rule
            }), {}), [
        rules
    ]);
    const getRule = (id)=>rulesById[id];
    const ruleHasInputs = (rule)=>rule?.userInputPrompts?.length > 0;
    const INVOCATIONS = 'invocations';
    const SUCCESS = 'SUCCESS';
    const getFailedObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] !== SUCCESS);
    const getSuccessfulObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] === SUCCESS);
    const handleInvocationFailure = (ruleId, successfulObjects, failedObjects)=>{
        if (onRuleInvocationFailure) onRuleInvocationFailure(ruleId, successfulObjects, failedObjects);
    };
    const invokeRule = async (ruleId, objects, userInputs)=>{
        const rule = getRule(ruleId);
        if (rule) {
            setInvokingRuleId(ruleId);
            try {
                if (onRuleInvocationLifecycleStarted) onRuleInvocationLifecycleStarted(ruleId, objects, userInputs);
                const response = await (0, $9Begw.invokeManuallyTriggeredRule)(env, site, ruleId, objects, userInputs);
                const failedObjects = getFailedObjects(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) {
                    if (onRuleInvocationSuccess) onRuleInvocationSuccess(ruleId, objects);
                } else {
                    const successfulObjects = getSuccessfulObjects(response);
                    handleInvocationFailure(ruleId, successfulObjects, failedObjects);
                }
            } catch (e) {
                handleInvocationFailure(ruleId, [], objects);
                setInvokingRuleId(null);
            }
        } else handleInvocationFailure(ruleId, [], objects);
        clearSelectedRule();
        if (onRuleInvocationLifecycleDone) onRuleInvocationLifecycleDone(ruleId, objects);
    };
    const invokeRuleOrShowDialog = (ruleId, objects)=>{
        const rule = getRule(ruleId);
        if (!rule) return handleInvocationFailure(ruleId, [], objects);
        if (ruleHasInputs(rule)) setSelectedRule({
            rule: rule,
            objects: objects
        });
        else invokeRule(ruleId, objects);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            children({
                triggerFetch: triggerFetch,
                initialised: initialised,
                error: error,
                rules: rules,
                invokingRuleId: invokingRuleId,
                invokeRuleOrShowDialog: invokeRuleOrShowDialog
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: selectedRule && /*#__PURE__*/ (0, $l998X.jsx)((0, $be85f4683a10666c$export$2e2bcd8739ae039), {
                    onInputsModalOpened: onInputsModalOpened,
                    onInputsModalClosed: onInputsModalClosed,
                    clearSelectedRule: clearSelectedRule,
                    selectedRule: selectedRule,
                    invokeRule: invokeRule
                })
            })
        ]
    });
};



var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");

const $4bac0f7515b59602$export$8e479e490e1e69bc = ({ spaceKey: spaceKey })=>{
    return `/wiki/spaces/${spaceKey}/settings/automation`;
};



var $71D5r = parcelRequire("71D5r");

const $e1d1978ef947919e$var$AutomationMenuContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e1d1978ef947919e$var$AutomationMenuProvider = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e1d1978ef947919e$var$AutomationMenuContext.Provider, {
        value: value
    }, children);
};
const $e1d1978ef947919e$export$9e222d3b7ca4dc6f = ()=>{
    const context = (0, $42omo.useContext)($e1d1978ef947919e$var$AutomationMenuContext);
    if (context === undefined) throw new Error('useAutomationMenu must be used within a AutomationMenuProvider');
    return context;
};
const $e1d1978ef947919e$var$i18n = (0, $cgtv4.defineMessages)({
    ruleInvocationSuccessTitle: {
        id: "automation-menu.flag.invocation.success.title",
        defaultMessage: "Your automation is in progress"
    },
    ruleInvocationFailureTitle: {
        id: "automation-menu.flag.invocation.failure.title",
        defaultMessage: "Oops we ran into a problem"
    },
    ruleInvocationFailureDescription: {
        id: "automation-menu.flag.invocation.failure.description",
        defaultMessage: "There was a problem and we couldn\u2019t run the automation"
    }
});
const $e1d1978ef947919e$export$235166e539b0088a = (0, $7aRa9.withFlags)(({ flags: flags, analyticsSource: analyticsSource, aris: aris, spaceKey: spaceKey, children: children, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone, singleSpace: singleSpace })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const mappedEnvironment = (0, $71D5r.mapEnv)(environment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dc9b564e50a41bb$export$eb0a81e78d942dba), {
        env: mappedEnvironment,
        site: (0, $b7C1K.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString(),
        query: {
            //if all pages are in same space, we only need one ari
            objects: singleSpace ? aris.slice(0, 1).map(String) : aris.map(String)
        },
        onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone,
        onRuleInvocationSuccess: ()=>{
            flags.hideFlag('automation-manual-trigger-execution-queued-flag').then(()=>flags.showInfoFlag({
                    id: 'automation-manual-trigger-execution-finished-flag',
                    title: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationSuccessTitle),
                    isAutoDismiss: true
                }));
        },
        onRuleInvocationFailure: ()=>{
            flags.hideFlag('automation-manual-trigger-execution-queued-flag').then(()=>flags.showErrorFlag({
                    id: 'automation-manual-trigger-execution-finished-flag',
                    title: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationFailureTitle),
                    description: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationFailureDescription),
                    isAutoDismiss: true
                }));
        }
    }, (props)=>{
        const baseAutomationUrl = (0, $4bac0f7515b59602$export$8e479e490e1e69bc)({
            spaceKey: spaceKey
        });
        const contextValue = {
            ...props,
            analyticsSource: analyticsSource,
            aris: aris,
            baseAutomationUrl: baseAutomationUrl,
            spaceKey: spaceKey
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e1d1978ef947919e$var$AutomationMenuProvider, {
            value: contextValue
        }, children()));
    });
});
module.exports["useAutomationMenu"] = $e1d1978ef947919e$export$9e222d3b7ca4dc6f;
module.exports["ConfluenceManualRulesContainer"] = $e1d1978ef947919e$export$235166e539b0088a;

});

parcelRegister("3Sibj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $13d50338b52b72c4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $31d57a9682dc7bc3$export$2e2bcd8739ae039 = {
    'automation-platform.common.cancel-button-title': 'Cancel',
    'automation-platform.common.continue-button-title': 'Continue',
    'automation-platform.common.error-input-character-limit-reached': 'Provided value exceeds the character limit for the field.',
    'automation-platform.common.error-input-must-not-be-empty': 'Input must not be empty',
    'automation-platform.common.error-input-type-is-not-supported': 'Input type not supported yet',
    'automation-platform.common.error-value-is-not-valid-number': 'The value is not a valid number',
    'automation-platform.common.failure-flag-description': "There was a problem and we couldn't run the automation '{0}'",
    'automation-platform.common.failure-flag-title': 'Oops we ran into a problem',
    'automation-platform.common.input-required-for-action': 'Your input is required to complete this action',
    'automation-platform.common.partial-failure-flag-description': "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
    'automation-platform.common.success-flag': 'Your automation is in progress',
    'automation-platform.footer.audit-log-item': 'Audit log',
    'automation-platform.footer.create-automation-item': 'Create automation',
    'automation-platform.footer.manage-automations-item': 'Manage automations',
    'automation-platform.manual-rules-empty-state.add-manually-triggered-automation': 'Add manually triggered automation',
    'automation-platform.manual-rules-empty-state.create-automations-button-title': 'You must be a project admin to create automations',
    'automation-platform.manual-rules-empty-state.empty-state-message-new': 'Create an automation to perform tasks with the click of a button. Once created, manually triggered automations will appear here.',
    'automation-platform.manual-rules-empty-state.see-templates': 'See templates'
};


var $13d50338b52b72c4$export$2e2bcd8739ae039 = (0, $31d57a9682dc7bc3$export$2e2bcd8739ae039);

});

parcelRegister("iyOBx", function(module, exports) {

let $d832a7f215558fbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d832a7f215558fbe$var$load("cDlXo").then(()=>parcelRequire('ffOuI'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("jsRDj", function(module, exports) {

let $e2ba3c4734783208$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e2ba3c4734783208$var$load("aGqxI").then(()=>parcelRequire('HihPs'));

});

parcelRegister("jPkry", function(module, exports) {

let $e6f2a366541ed1bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6f2a366541ed1bd$var$load("8DMgV").then(()=>parcelRequire('fsyMU'));

});

parcelRegister("6U5fO", function(module, exports) {

let $506c0c65142b64cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $506c0c65142b64cc$var$load("3lwWF").then(()=>parcelRequire('bXu7U'));

});

parcelRegister("fBcrb", function(module, exports) {

let $b5b3f58c0670f760$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5b3f58c0670f760$var$load("6n44e").then(()=>parcelRequire('fIcrj'));

});

parcelRegister("0Wkda", function(module, exports) {

let $002d3e54804263c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $002d3e54804263c5$var$load("i2lSs").then(()=>parcelRequire('eXNSM'));

});

parcelRegister("c19lr", function(module, exports) {

let $8bfcd3baa9af8ce7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8bfcd3baa9af8ce7$var$load("cddHY").then(()=>parcelRequire('992tZ'));

});

parcelRegister("lNzdD", function(module, exports) {

let $fde97e4cc443bb8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fde97e4cc443bb8f$var$load("2nFnK").then(()=>parcelRequire('2WYSk'));

});

parcelRegister("bvax8", function(module, exports) {

let $85fac2acfd7dd7c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85fac2acfd7dd7c3$var$load("iMEy4").then(()=>parcelRequire('49B6r'));

});

parcelRegister("kwuXM", function(module, exports) {

let $ef0ed077a4eb2336$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ef0ed077a4eb2336$var$load("79NWg").then(()=>parcelRequire('3pVwt'));

});

parcelRegister("9Vmiq", function(module, exports) {

let $739abb7d6e95f587$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $739abb7d6e95f587$var$load("dn37Z").then(()=>parcelRequire('5EDpZ'));

});

parcelRegister("iMCok", function(module, exports) {

let $daca7d65d153c545$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $daca7d65d153c545$var$load("2y34H").then(()=>parcelRequire('bhYx9'));

});

parcelRegister("8OMYj", function(module, exports) {

let $66b8fb01b5c72797$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66b8fb01b5c72797$var$load("g8Vga").then(()=>parcelRequire('gEuQF'));

});

parcelRegister("3N9j9", function(module, exports) {

let $2c2d2b0c0f3e4de9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c2d2b0c0f3e4de9$var$load("fw5Rx").then(()=>parcelRequire('kHvxY'));

});

parcelRegister("bY50g", function(module, exports) {

let $8b692dd838e411f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8b692dd838e411f2$var$load("cqxYX").then(()=>parcelRequire('gqKDs'));

});

parcelRegister("8stZc", function(module, exports) {

let $628832dfca94dc33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $628832dfca94dc33$var$load("3Wq1f").then(()=>parcelRequire('8kp3a'));

});

parcelRegister("lWYjb", function(module, exports) {

let $ffadcbbd3fb2f710$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffadcbbd3fb2f710$var$load("ePmaE").then(()=>parcelRequire('89grd'));

});

parcelRegister("3eNpQ", function(module, exports) {

let $25b902d9c1dbc056$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25b902d9c1dbc056$var$load("2PbJR").then(()=>parcelRequire('UbYBp'));

});

parcelRegister("hGqDY", function(module, exports) {

let $cdfb06c8c709a445$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cdfb06c8c709a445$var$load("04oVB").then(()=>parcelRequire('1rTgi'));

});

parcelRegister("5bE1l", function(module, exports) {

let $3c6d06169193db84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c6d06169193db84$var$load("7lf25").then(()=>parcelRequire('cYk97'));

});

parcelRegister("a4LUc", function(module, exports) {

let $755f702291e1f22e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $755f702291e1f22e$var$load("csVFP").then(()=>parcelRequire('cORc0'));

});

parcelRegister("kT5zt", function(module, exports) {
/* Skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8bed93993cee5a0$var$AutomationSkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4x7n9",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s813su _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonIcon = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkolb4i _19it5u6v _1bsb7vkz _4t3i7vkz _1e0c1o8l _bfhk1r31 _tzy4nh7s",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$MenuIcon = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8bed93993cee5a0$var$SkeletonText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb13sl _4t3ipxbi _19pk1b66 _18u0utpp _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkizff _1itkx7de _12vemgnk",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonLine = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8bed93993cee5a0$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8bed93993cee5a0$var$MenuIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8bed93993cee5a0$var$SkeletonIcon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8bed93993cee5a0$var$SkeletonText, null));
const $f8bed93993cee5a0$var$getSkeletonLines = (lineCount)=>{
    const skeletonLines = [];
    for(let i = 0; i < lineCount; i++)skeletonLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8bed93993cee5a0$var$SkeletonLine, {
        key: `skeleton-line-${i}`
    }));
    return skeletonLines;
};
const $f8bed93993cee5a0$export$8f31e4c4a37b8e9c = (props)=>{
    const { lineCount: lineCount = 5 } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8bed93993cee5a0$var$AutomationSkeletonContainer, null, $f8bed93993cee5a0$var$getSkeletonLines(lineCount));
};
module.exports["Skeleton"] = $f8bed93993cee5a0$export$8f31e4c4a37b8e9c;

});


//# sourceMappingURL=PageQuickActionAutomationMenu.e6e5de7f.js.map
